export default __webpack_public_path__ + "static/header-e24ec090219cda15f5a7eaf3afb67ba8.png";